export default {"src":"/_next/static/media/icon-instagram.30b3a93b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};